import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { ParentService } from 'app/pages/A2-utils/ParentClass/ParentService';
import { constant } from 'app/app.constants';

@Injectable()
export class VersionService extends ParentService  {


  constructor(private _http: Http) {
    super();
  }

  /**
   * @description Leer la version local de la app
   */
  getLocalVersion() {
    return this._http.get('./info.json')
    .map(
      success => success.json(),
      error => error.json()
    );
  }

  getServerVersionWebApp() {
    return this._http
      .get(constant.URL_VERSION_WEBAPP, this.getHeader())
      .map(res => res.json(), error => error.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/version/version.service.ts